import {useState} from "react";
import moment from "moment";

//функция чтобы текущий месяц в расходах и доходах был открыт по умолчанию
const getCurrentDateKeys = () => {
    const now = moment();
    const year = now.format('YYYY');
    const month = now.format('MMMM').toLowerCase();
    const monthKey = `${year}${month}`;

    // Дефолтное состояние: год и месяц открыты
    const defaultState = {
        [year]: true,
        [monthKey]: true,
    };

    // Добавляем все дни месяца в формате "D MMMM" (например, "1 мая")
    const daysInMonth = now.daysInMonth();

    for (let day = 1; day <= daysInMonth; day++) {
        const dateStr = moment([now.year(), now.month(), day]).format('D MMMM');
        defaultState[`${monthKey}${dateStr}`] = true; // Формат: "2025май1 мая", "2025май2 мая", ...
    }

    return defaultState;
};

const loadState = (tableId) => {
    const saved = localStorage.getItem(`tableState-${tableId}`);
    const defaultState = getCurrentDateKeys();

    return saved ? { ...defaultState, ...JSON.parse(saved) } : defaultState;
};

const saveState = (tableId, state) => {
    localStorage.setItem(`tableState-${tableId}`, JSON.stringify(state));
};

export const useTableToggle = (tableId) => {
    const [openSections, setOpenSections] = useState(() => loadState(tableId));

    const toggle = (id) => {
        setOpenSections((prev) => {
            const newState = { ...prev, [id]: !prev[id] };
            saveState(tableId, newState);
            return newState;
        });
    };

    const isOpened = (id) => Boolean(openSections[id]);

    return { toggle, isOpened };
};